import { Button, Flex, Text } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';

import CreateOrgButton from '@features/onboarding/CreateOrgButton';
import { getNextStepPath } from '@features/onboarding/config';
import { useHref } from 'hooks/useHref';
import { IUserOrg } from 'stores/orgStore';
import { ModalType } from 'stores/pageStore';
import { useOnboardingStore, usePageStore, useUserStore } from 'stores/rootStore';
import { LoginStatus } from 'stores/userStore';
import Plus from 'vectors/Plus';

const CreateBusinessPromo = () => {
  const userStore = useUserStore();
  const pageStore = usePageStore();
  const onboardingStore = useOnboardingStore();
  const router = useRouter();
  const isLoggedIn = userStore.status === LoginStatus.LoggedIn;
  const { onboardingFullUrl } = useHref();

  const openLoginModal = useCallback(() => {
    pageStore.openModal(ModalType.Login);
    pageStore.setLoginRedirectUrl(onboardingFullUrl());
  }, [pageStore, onboardingFullUrl]);

  const onOrgCreated = useCallback(
    (org: IUserOrg) => {
      onboardingStore.setSelectedOrgId(org.id);
      const nextStepPath = getNextStepPath('add-business');
      if (nextStepPath != null) {
        router.push(nextStepPath);
      }
    },
    [onboardingStore, router],
  );

  return (
    <Flex
      flexDirection="column"
      gap={3}
      p={3}
      mx={2}
      mb={2}
      borderRadius="lg"
      borderWidth={1}
      borderColor="sidebar.hover"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontSize="sm" fontWeight="medium">
          Unlock more capabilities with a business account
        </Text>
      </Flex>
      {isLoggedIn ? (
        <CreateOrgButton
          title="Create a business"
          size="xs"
          borderRadius="md"
          popoverMinWidth={280}
          onOrgCreated={onOrgCreated}
        />
      ) : (
        <Button variant="solid" onClick={openLoginModal} size="xs" borderRadius="md">
          <Plus /> Create a business
        </Button>
      )}
    </Flex>
  );
};

export default observer(CreateBusinessPromo);
